/**
 * Converter para atributos booleanos que maneja correctamente strings "true"/"false"
 * Convención de Web Components:
 * - Atributo presente (cualquier valor) o "true" → true
 * - Atributo ausente, "false", "0", "" → false
 */
export const booleanConverter = {
  fromAttribute: (value: string | null): boolean => {
    if (value === null) return false;
    if (value === '' || value === 'true') return true;
    if (value === 'false' || value === '0') return false;
    // Para otros valores, seguir la convención: si existe el atributo es true
    return true;
  },
  toAttribute: (value: boolean): string => {
    return value ? 'true' : 'false';
  }
};
